import { render, staticRenderFns } from "./ArrowUpStudents.vue?vue&type=template&id=3fe9c603"
import script from "./ArrowUpStudents.vue?vue&type=script&lang=js"
export * from "./ArrowUpStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports